import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from '../app-component-base';
import { DocumentsUploadFormComponent } from '../documents-upload-form/documents-upload-form.component';

@Component({
    selector: 'app-document-list',
    templateUrl: './document-list.component.html',
    styleUrls: ['./document-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class DocumentListComponent extends AppComponentBase implements OnInit {
    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @Output() emitDocList: EventEmitter<any> = new EventEmitter<any>();
    @Input() accountId: any;
    @Input() isAccountDoc: boolean = true;

    public documentsCount = 0;
    selectedDocuments: string[] = [];
    uploadData = {
        files: [],
        orderId: ''
    };
    isFormLoading = false;

    constructor(
        injector: Injector,
        private dialog: MatDialog,
        private commonService: CommonService,
        private toastr: ToastrService,
        private router: Router) {
        super(injector);
    }

    ngOnInit() {
        this.onRefreshGridData();
    }

    onRefreshGridData(): void {
        this.kendogridHelper.sort = [{ dir: 'desc', field: 'size' }];
        this.grid.dataStateChange.emit({
            skip: 0,
            take: this.kendogridHelper.defaultRecordsCountPerPage,
            filter: undefined,
            group: undefined,
            sort: this.kendogridHelper.sort,
        });
    }

    getGridRecords(event: DataStateChangeEvent): void {
        if (event) {
            this.kendogridHelper.dataStateChangeEvent(event);
        }
        this.kendogridHelper.showLoadingIndicator();
        this.commonService.getOrderDocumentsGridRecords(event, `&AccountId=${this.accountId}&IsAccountDoc=true&DocumentTypeId=8`, '')
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
                if (response.isSuccess) {
                    this.kendogridHelper.setGridData(response.data);
                    this.documentsCount = response.data.items.length;
                    this.emitDocList.emit();
                    this.kendogridHelper.hideLoadingIndicator();
                }
            });
    }

    onDocuments() {
        this.dialog.open(DocumentsUploadFormComponent, {
            position: {
                right: '0',
            },
            panelClass: 'small_layout',
            hasBackdrop: false,
            data: { accountId: this.accountId },
            autoFocus: false
        }).afterClosed().subscribe((response: any) => {
            if (response) {
                this.onRefreshGridData();
            }
        });
    }

    onViewDocument(dataItem: any) {
        window.open(dataItem.blobUrl, '_blank');
    }

    onDownloadDocument(dataItem: any) {
        this.kendogridHelper.showLoadingIndicator();
        this.commonService.getDocumentFile(dataItem.id)
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
                this.kendogridHelper.hideLoadingIndicator();
                if (response.status === 200) {
                    const data: any = response;
                    this.commonService.downloadBolbFile(data.body as any, { type: data.body.type }, `${dataItem.name}`);
                }
            });
    }

    onRemoveDocument(documentId: string) {
        this.kendogridHelper.showLoadingIndicator();
        this.commonService.deleteOrderDocument({ documentId, isActive: false })
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
                this.kendogridHelper.hideLoadingIndicator();
                if (response.isSuccess) {
                    this.toastr.success(response.errors || 'Document Deleted successfully');
                    this.onRefreshGridData();
                }
            });
    }

    onChangeApplyToAllJob(dataItem: any) {
        this.kendogridHelper.showLoadingIndicator();
        this.commonService.documentApplyToAllJobs({ documentId: dataItem.documentId, IsApplyToAllJobs: dataItem.isApplyToAllJobs })
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
                this.kendogridHelper.hideLoadingIndicator();
                if (response.isSuccess) {
                    this.toastr.success('Update successfull');
                    this.onRefreshGridData();
                }
                else {
                    this.toastr.success(response.errors);
                }
            });
    }

    onUploadClick() {
        this.isFormLoading = true;
        this.uploadData.files = this.selectedDocuments.map((result) => {
            return {
                orderId: this.router.url.split('=')[1],
                documentId: result
            };
        });
        this.uploadData.orderId = this.router.url.split('=')[1];
        this.commonService.orderUploadAccountDocument(this.uploadData)
            .pipe().subscribe(response => {
                this.isFormLoading = false;
                this.toastr.success('Documents uploaded successfully');
                this.dialog.closeAll();
            });
    }

}


